export default "__VITE_ASSET__CFnNqzmY__"